export default "__VITE_PUBLIC_ASSET__05b06eb0__"